import {
  SET_POSTS,
  LOADING_POSTS,
  LOADING_POSTDIALOG,
  LOADING_PROFILE,
  LOADING_NEWPOST,
  //LOADING_CREDENTIALS,
  LIKE_POST,
  UNLIKE_POST,
  SAVE_POST,
  UNSAVE_POST,
  DELETE_POST,
  SET_ERRORS,
  POST_POST,
  CLEAR_ERRORS,
  //LOADING_UI,
  SET_POST,
  //STOP_LOADING,
  SUBMIT_COMMENT,
  SET_SAVED_POSTS,
  SET_PROFILE,
  STOP_LOADING_POSTS,
  STOP_LOADING_POSTDIALOG,
  STOP_LOADING_NEWPOST,
  STOP_LOADING_PROFILE,
} from "../types";
import axios from "axios";

// Get all posts
export const getPosts = () => (dispatch) => {
  dispatch({ type: LOADING_POSTS });
  axios
    .get("/posts")
    .then((res) => {
      console.log(res.data)
      dispatch({
        type: SET_POSTS,
        payload: res.data,
      });
      dispatch({ type: STOP_LOADING_POSTS });
    })
    .catch((err) => {
      console.log(err)
      // dispatch({
      //   type: SET_ERRORS,
      //   payload: err.response.data,
      // });
    });
};
export const getPost = (postId) => (dispatch) => {
  dispatch({ type: LOADING_POSTDIALOG });
  axios
    .get(`/post/${postId}`)
    .then((res) => {
      dispatch({
        type: SET_POST,
        payload: res.data,
      });
     dispatch({ type: STOP_LOADING_POSTDIALOG });
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};
// Post a post
export const postPost = (formData) => (dispatch) => {
dispatch({ type: LOADING_NEWPOST });

  // console.log(...formData);
  axios
    .post("/post", formData)
    .then((res) => {
      dispatch({
        type: POST_POST,
        payload: res.data,
      });
      dispatch({ type: STOP_LOADING_NEWPOST });
      //dispatch(clearErrors());
      console.log(res);
    })
    .catch((err) => {
      console.log(err);
      // dispatch({
      //   type: SET_ERRORS,
      //   payload: err.response.data,
      // });
    });
};
// Like a post
export const likePost = (postId, handle) => (dispatch) => {
  axios
    .get(`/post/${postId}/like`)
    .then((res) => {      
      var respData = {...res.data, likeHandle: handle};      
      dispatch({
        type: LIKE_POST,
        payload: respData,
      });
    })
    .catch((err) => {
      console.log(err)
      // dispatch({
      //   type: SET_ERRORS,
      //   payload: err.response.data,
      // });
    });
};
// Unlike a post
export const unlikePost = (postId, handle) => (dispatch) => { 
  axios
    .get(`/post/${postId}/unlike`)
    .then((res) => {
      var respData = {...res.data, userHandle: handle};      
      dispatch({
        type: UNLIKE_POST,
        payload: respData,
      });
    })
    .catch((err) => {
      console.log(err)
      // dispatch({
      //   type: SET_ERRORS,
      //   payload: err.response.data,
      // });
    });
};

// Save a post to your wardrobe
export const savePost = (post) => (dispatch) => {
  axios
    .post(`/save`, post)
    .then((res) => {
      dispatch({
        type: SAVE_POST,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err)
      // dispatch({
      //   type: SET_ERRORS,
      //   payload: err.response.data,
      // });
    });
};

export const unsavePost = (post) => (dispatch) => {
  axios
    .post(`/unsave`, post)
    .then((res) => {
      dispatch({
        type: UNSAVE_POST,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};

// Submit a comment
export const submitComment = (postId, commentData) => (dispatch) => {
  axios
    .post(`/post/${postId}/comment`, commentData)
    .then((res) => {
      dispatch({
        type: SUBMIT_COMMENT,
        payload: res.data,
      });
      dispatch(clearErrors());
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};
export const deletePost = (postId) => (dispatch) => {
  axios
    .delete(`/post/${postId}`)
    .then(() => {
      dispatch({ type: DELETE_POST, payload: postId });
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getSavedPosts = (postIDs) => (dispatch) => {
  dispatch({ type: LOADING_POSTS });
  axios
      .post("/savedPosts", postIDs)
      .then((res) => {
        dispatch({
          type: SET_SAVED_POSTS,
          payload: res.data,
        });
        dispatch({ type: STOP_LOADING_POSTS });
        console.log(res.data);
        return res.data;
      })
      .catch((err) => {
        dispatch({
          type: SET_ERRORS,
          payload: err.response.data,
        });
      });
};

export const getUserData = (userHandle) => (dispatch) => {
  dispatch({ type: LOADING_PROFILE });
  axios
    .get(`/user/${userHandle}`)
    .then((res) => {
      dispatch({
        type: SET_PROFILE,
        payload: res.data,
      });
      dispatch({ type: STOP_LOADING_PROFILE });
    })
    .catch((err) => {
      console.log(err)
      // dispatch({
      //   type: SET_ERRORS,
      //   payload: err.response.data,
      // });
    });
};

//** If we need to move the axios command from Postpost.js
// for getting the product info it will go below */

export const getProductFromUrl = (itemUrl) => (dispatch) => {
  dispatch({ type: LOADING_NEWPOST });
  axios
      .post(`/item`, itemUrl)
      .then((res) => {
        // this.setState({ ...res.data });
        dispatch({ type: STOP_LOADING_NEWPOST });
        console.log(res.data);
        return res.data;
      })
      .catch((err) => console.log(err));
  
};

export const clearErrors = () => (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
